__turbopack_context__.v({
  "amount": "UnpaidOrderNotice-module__rvaRPW__amount",
  "badge": "UnpaidOrderNotice-module__rvaRPW__badge",
  "description": "UnpaidOrderNotice-module__rvaRPW__description",
  "floatingButton": "UnpaidOrderNotice-module__rvaRPW__floatingButton",
  "modalTitle": "UnpaidOrderNotice-module__rvaRPW__modalTitle",
  "orderDate": "UnpaidOrderNotice-module__rvaRPW__orderDate",
  "orderItem": "UnpaidOrderNotice-module__rvaRPW__orderItem",
  "orderList": "UnpaidOrderNotice-module__rvaRPW__orderList",
  "orderNumber": "UnpaidOrderNotice-module__rvaRPW__orderNumber",
  "payNow": "UnpaidOrderNotice-module__rvaRPW__payNow",
  "right": "UnpaidOrderNotice-module__rvaRPW__right",
});
